import { render, staticRenderFns } from "./PerformanceRevenueEdit.vue?vue&type=template&id=2196a408&scoped=true"
import script from "./PerformanceRevenueEdit.vue?vue&type=script&lang=js"
export * from "./PerformanceRevenueEdit.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRevenueEdit.vue?vue&type=style&index=0&id=2196a408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196a408",
  null
  
)

export default component.exports